import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

import { BaseEntityLink } from "~/components/base-entity-link";

export const StyledBaseEntityLink = styled(BaseEntityLink)``;

export const MenuItem = styled.span`
  color: #001246;
  font-size: 15px;
  font-family: ${fontRobotoCondensed};
  line-height: 18px;
`;

export const Container = styled.div`
  ${StyledBaseEntityLink}:first-child {
    padding-inline-start: 0;
  }

  ${StyledBaseEntityLink} {
    padding-inline-start: 12px;
  }

  /** Hide the items to prevent overflow in desktop */
  ${props => props.theme.breakpoints.only("desktop")} {
    ${StyledBaseEntityLink}:nth-child(n+10) {
      display: none;
    }
  }

  /** Hide the items to prevent overflow in medium desktop */
  ${props => props.theme.breakpoints.only("mediumDesktop")} {
    ${StyledBaseEntityLink}:nth-child(n+11) {
      display: none;
    }
  }

  ${props => props.theme.breakpoints.up("mediumDesktop")} {
    ${StyledBaseEntityLink} {
      padding-inline-start: 16px;
    }
  }
`;
